import {
  ACCOUNTSTATUS_LOAD, ACCOUNTSTATUS_LOAD_SUCCESS, ACCOUNTSTATUS_LOAD_FAIL,
  INTRANSIT_LOAD, INTRANSIT_LOAD_SUCCESS, INTRANSIT_LOAD_FAIL,
  PURCHASEDITEMSUMMARYINFO_LOAD, PURCHASEDITEMSUMMARYINFO_LOAD_SUCCESS, PURCHASEDITEMSUMMARYINFO_LOAD_FAIL,
  PURCHASEDITEMDETAILS_LOAD, PURCHASEDITEMDETAILS_LOAD_SUCCESS, PURCHASEDITEMDETAILS_LOAD_FAIL,
  BONUSDETAILS_LOAD, BONUSDETAILS_LOAD_SUCCESS, BONUSDETAILS_LOAD_FAIL,
  STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD, STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_SUCCESS, STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_FAIL,
  SUBMIT_TRANCEFERENCE_LOAD, SUBMIT_TRANCEFERENCE_LOAD_SUCCESS, SUBMIT_TRANCEFERENCE_LOAD_FAIL,
} from './actions';

import {
  EVENT_SUMMARY_INFO, EVENT_SUMMARY_INFO_SUCCESS, EVENT_SUMMARY_INFO_FAIL,
} from '../../eventManagement/page/GiftList/actions';


const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  extraData: {},
  accountStatus: {},
  intransit: [],
  purchasedItemSummaryInfoData: {},
  purchasedItemsDetailsData: {},
  eventInfo: {},
  bonusDetailsData: {},
  statementDetailsForPrintAndDownloadData: {},
  partialTransferData: {},
  submitTransference: {},
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACCOUNTSTATUS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case ACCOUNTSTATUS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        accountStatus: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case ACCOUNTSTATUS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        accountStatus: null,
        error: action.error,
      };
    case INTRANSIT_LOAD:
      return {
        ...state,
        loading: true,
      };
    case INTRANSIT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        intransit: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case INTRANSIT_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        intransit: null,
        error: action.error,
      };

    case PURCHASEDITEMSUMMARYINFO_LOAD:
      return {
        ...state,
        loading: true,
      };
    case PURCHASEDITEMSUMMARYINFO_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        purchasedItemSummaryInfoData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case PURCHASEDITEMSUMMARYINFO_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        purchasedItemSummaryInfoData: null,
        error: action.error,
      };


    case PURCHASEDITEMDETAILS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case PURCHASEDITEMDETAILS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        purchasedItemsDetailsData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case PURCHASEDITEMDETAILS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        purchasedItemsDetailsData: null,
        error: action.error,
      };
    case EVENT_SUMMARY_INFO:
      return {
        ...state,
        loading: true,
      };
    case EVENT_SUMMARY_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        eventInfo: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case EVENT_SUMMARY_INFO_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        eventInfo: null,
        error: action.error,
      };
    case BONUSDETAILS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case BONUSDETAILS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        bonusDetailsData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case BONUSDETAILS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        statementDetailsForPrintAndDownloadData: null,
        error: action.error,
      };

    case STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD:
      return {
        ...state,
        loading: true,
      };
    case STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        statementDetailsForPrintAndDownloadData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case STATEMENTDETAILSFORPRINTANDDOWNLOAD_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        statementDetailsForPrintAndDownloadData: null,
        error: action.error,
      };


    case SUBMIT_TRANCEFERENCE_LOAD:
      return {
        ...state,
        loading: true,
      };
    case SUBMIT_TRANCEFERENCE_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        submitTransference: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case SUBMIT_TRANCEFERENCE_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        submitTransference: null,
        error: action.error,
      };
    default:
      return state;
  }
}
